"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const Button_1 = require("@Components/Buttons/Button");
const react_helmet_1 = __importDefault(require("react-helmet"));
const user_1 = require("@App/api/routes/user");
const mobx_react_1 = require("mobx-react");
const ChangePasswordStep_1 = __importDefault(require("@Scenes/ForgotPasswordScene/ChangePasswordStep"));
const react_router_dom_1 = require("react-router-dom");
const common_1 = require("@Const/common");
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const ChangePasswordScene = () => {
    const [hasBeenUpdated, setHasBeenUpdated] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('change_password');
        (0, user_1.sendPasswordResetCode)().then();
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: "Change password" }),
        react_1.default.createElement("main", { className: "change-password-scene" },
            react_1.default.createElement(react_router_dom_1.NavLink, { to: '/profile', className: "close-wrapper" },
                react_1.default.createElement("img", { src: common_1.ICONS.close, alt: "close" })),
            react_1.default.createElement("div", { className: "global-container password-reset-content" }, hasBeenUpdated ? (react_1.default.createElement(Button_1.Button, { className: 'return-button', mainColor: true, type: 'primary', linkTo: '/profile', typeLink: true }, "Return to profile")) : (react_1.default.createElement(ChangePasswordStep_1.default, { setHasBeenUpdated: setHasBeenUpdated }))))));
};
exports.default = (0, mobx_react_1.observer)(ChangePasswordScene);
